export class ErrorLayout {
  static timl = `
    .error-page[component="?"]
  `
}

class FullPageLayout {
  static timl = `
    aside
      .aside-content
        header
    main
      .page  
        .max-width-center[component="?"]
  `
}

export class MainLayout {
  static timl = `
    aside
      .aside-content
        header.dflex
          a.logo[href="/"]
            <img src="/instant-suite-logo.png" alt="Instant-Suite logo" class="brand-mark-suite" width="37" height="37">
          a.nav-button[onclick="showAside()" aria-label="Toggle navigation"]
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" viewBox="0 0 283.426 283.426" xml:space="preserve"><g><rect x="0" y="40.84" style="fill:#010002;" width="283.426" height="47.735"/><rect x="0" y="117.282" style="fill:#010002;" width="283.426" height="47.735"/><rect x="0" y="194.851" style="fill:#010002;" width="283.426" height="47.735"/></g></svg>
          div.logo-flex
            div
              a[href="/"]
                span.brand-wordmark
                  span.brand-wordmark-prefix Instant-
                  span.brand-wordmark-suffix.brand-wordmark-suite Suite
            div
              a.f12.ml-4[href="/admins/{{ Auth.user.id }}/edit"] {{ Auth.user.email }}
        nav.authenticated
          a[href="/"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z" clip-rule="evenodd"></path></svg>  
            span Dashboard
          a[href="/auth"]
            <img src="/instant-auth-logo.png" alt="Instant-Auth logo" class="brand-mark-auth" width="27" height="27">
            span.brand-wordmark
              span.brand-wordmark-prefix Instant-
              span.brand-wordmark-suffix.brand-wordmark-auth Auth
          a[href="/forms"] 
            <img src="/instant-forms-logo.png" alt="Instant-Forms logo" class="brand-mark-forms" width="27" height="27">
            span.brand-wordmark
              span.brand-wordmark-prefix Instant-
              span.brand-wordmark-suffix.brand-wordmark-forms Forms
          a[href="/surveys"] 
            <img src="/instant-surveys-logo.png" alt="Instant-Surveys logo" class="brand-mark-surveys" width="27" height="27">
            span.brand-wordmark
              span.brand-wordmark-prefix Instant-
              span.brand-wordmark-suffix.brand-wordmark-surveys Surveys

        nav.unauthenticated
          a[href="/login"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clip-rule="evenodd"></path></svg>
            span Login
          a[href="/register"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"></path></svg>
            span Register
          a[href="/forgot-password"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M8 7a5 5 0 1 1 3.61 4.804l-1.903 1.903A1 1 0 0 1 9 14H8v1a1 1 0 0 1-1 1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L8.196 8.39A5.002 5.002 0 0 1 8 7Zm5-3a.75.75 0 0 0 0 1.5A1.5 1.5 0 0 1 14.5 7 .75.75 0 0 0 16 7a3 3 0 0 0-3-3Z" clip-rule="evenodd"></path></svg>
            span Forgot Password
          a[href="/confirm-email"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path d="M3.505 2.365A2.25 2.25 0 0 1 5.06 1.75h9.88a2.25 2.25 0 0 1 1.555.615l.69.659L10 8.638 2.815 3.024l.69-.659Z"></path><path d="M2 4.79v8.96A2.25 2.25 0 0 0 4.25 16h11.5A2.25 2.25 0 0 0 18 13.75V4.79l-7.385 5.768a1 1 0 0 1-1.23 0L2 4.79Z"></path><circle cx="10" cy="10.5" r="3.25" fill="#fff"></circle><path fill-rule="evenodd" d="M12.28 9.22a.75.75 0 0 1 0 1.06l-2.03 2.03a.75.75 0 0 1-1.06 0L8.03 11.16a.75.75 0 0 1 1.06-1.06l.63.63 1.5-1.5a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"></path></svg>
            span Confirm Email
          a[href="/resend-confirmation"]
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path d="M3.505 2.365A2.25 2.25 0 0 1 5.06 1.75h9.88a2.25 2.25 0 0 1 1.555.615l.69.659L10 8.638 2.815 3.024l.69-.659Z"></path><path d="M2 4.79v8.96A2.25 2.25 0 0 0 4.25 16h11.5A2.25 2.25 0 0 0 18 13.75V4.79l-7.385 5.768a1 1 0 0 1-1.23 0L2 4.79Z"></path></svg>
            span Resend Confirmation
        footer
          nav.authenticated
            a[href="/admins"]
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" /></svg>
              span Admins
            a[href="/billing"]
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">  <rect x="2" y="5" width="20" height="14" rx="3"/>  <rect x="2" y="8" width="20" height="3" fill="white"/>  <rect x="5" y="14" width="6" height="2" rx="1" fill="white"/></svg>
              span Billing
            a[href="/brands"]
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path d="M10 2C5.582 2 2 5.134 2 9c0 1.73.72 3.318 1.92 4.54C5.19 14.82 6 15.17 6.75 15.17h1.04c.58 0 1.05.47 1.05 1.05 0 .97.79 1.76 1.76 1.76H12c3.314 0 6-2.686 6-6 0-5.523-3.582-9.98-8-9.98Zm-3 7.25A1.25 1.25 0 1 1 7 6.75a1.25 1.25 0 0 1 0 2.5Zm3-3A1.25 1.25 0 1 1 10 3.75a1.25 1.25 0 0 1 0 2.5Zm3.25 3A1.25 1.25 0 1 1 13.25 6a1.25 1.25 0 0 1 0 2.5Zm1.25 4A1.25 1.25 0 1 1 14.5 10.75a1.25 1.25 0 0 1 0 2.5Z"/></svg>
              span Brands
            .sidebar-ornamental-divider[aria-hidden="true"]
            a[href="/help"]
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM7.25 7.5A2.75 2.75 0 0 1 10 4.75a2.75 2.75 0 0 1 2.126 4.494c-.37.454-.626.794-.626 1.256v.25a.75.75 0 0 1-1.5 0v-.25c0-1.01.578-1.719.965-2.193A1.25 1.25 0 1 0 8.75 7.5a.75.75 0 0 1-1.5 0ZM10 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd"></path></svg>
              span Help
            a[href="/support"]
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M2 10a8 8 0 1 1 14.32 4.906l1.387 2.774A.75.75 0 0 1 17.036 19l-3.623-1.208A7.965 7.965 0 0 1 10 18a8 8 0 0 1-8-8Zm5.25-1.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm0 3a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z" clip-rule="evenodd"></path></svg>
              span Support
            .sidebar-ornamental-divider[aria-hidden="true"]
            a.authenticated[href="/logout"] 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M2 4.75A2.75 2.75 0 0 1 4.75 2h3a2.75 2.75 0 0 1 2.75 2.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.75 2.75 0 0 1 7.75 14h-3A2.75 2.75 0 0 1 2 11.25v-6.5Zm9.47.47a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97H5.25a.75.75 0 0 1 0-1.5h7.19l-.97-.97a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path></svg>
              span Logout
    main
      .page
        .max-width-center[component="?"]
  `
}

// mobile nav
function showAside() {
  document.querySelector('aside')?.classList.toggle('is-open');
}
function hideAside() {
  document.querySelector('aside')?.classList.remove('is-open');
}

globalThis.showAside = showAside;
globalThis.hideAside = hideAside;
